import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { TopBar, MainDrawer } from './components';
import { useIsMobile } from 'src/hooks/use-is-mobile';
import { DashboardDrawer } from 'src/components/drawer/DashboardDrawer';
import useResolution from 'src/hooks/useResolution';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const { actions: appActions, selectors: appSelectors } = slices.app;

export const DashboardLayout = () => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { lg_plus } = useResolution();
  const dispatch = useAppDispatch();

  const isDrawerOpen = useAppSelector(appSelectors.selectIsDrawerOpen);

  const toggleDrawerOpen = () => {
    dispatch(appActions.toggleDrawerOpen());
  };

  useEffect(() => {
    if (isMobile || lg_plus) dispatch(appActions.closeDrawer());
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  return (
    <div className={classes.root}>
      <TopBar isDrawerOpen={isDrawerOpen} toggleDrawerOpen={toggleDrawerOpen} />
      {isMobile || lg_plus ? (
        <DashboardDrawer open={isDrawerOpen} onClose={toggleDrawerOpen} />
      ) : (
        <MainDrawer onClose={toggleDrawerOpen} open={isDrawerOpen} />
      )}
      <div
        className={classes.wrapper}
        style={{
          ...(isDrawerOpen && !lg_plus && { paddingLeft: 280 })
        }}
      >
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
